


























import { Component, Vue } from 'vue-property-decorator';
import NumberKeyboard from './components/NumberKeyboard.vue';
import GuessList from './components/GuessList.vue';
import GuessBoard from './components/GuessBoard.vue';

@Component({
  components: {
    NumberKeyboard,
    GuessList,
    GuessBoard,
  },
})
export default class App extends Vue {
  get answer() {
    return this.$store.getters.getAnswer();
  }

  get hasWon() {
    return this.$store.getters.hasWon();
  }

  get level() {
    return this.$store.getters.getLevel();
  }

  public onResetClick(e: any) {
    this.$store.dispatch('resetGame');
  }

  public created() {
    this.$store.dispatch('resetGame');
  }
}
